import { Tab, Tabs } from "@mui/material";
import { toStdDate } from "../../utils/dates";
import { useContext, useEffect } from "react";
import { useNotification } from '../../context/NotificationContext';

import SignalREncorehiveContext from '../../context/signalREncorehive';

const DaysTabs = ({ sortedSwarms, handleTabChange, selectedTimeTab }) => {

  const { signalREncorehive } = useContext(SignalREncorehiveContext);
  const { showNotification } = useNotification();  

  useEffect(() => {

    if (!signalREncorehive) return;

    const NewSwarmForMonitorFromDrops = (isMonitor, eventName) => {
      if (isMonitor) {
        showNotification(
          <>
            <div>The event {eventName} has been moved to Monitor for Drops, meaning we're still interested in approving more purchases.</div>
            <div>New tickets may appear at any time. Keep checking and be prepared to act quickly!</div>
          </>,
          'success'
        );
      }
    };

    signalREncorehive.on("NewSwarmForIsMonitor", NewSwarmForMonitorFromDrops);

    return () => {
      signalREncorehive.off("NewSwarmForIsMonitor", NewSwarmForMonitorFromDrops);
    };

  }, []); 

  console.log("DEBUG: DaysTabs.jsx: DaysTabs: sortedSwarms: ", sortedSwarms)
  // Function to determine the label of each tab
    const renderTabLabel = (salesDate) => {
      if (salesDate === "Monitor For Drops") {
        return salesDate;
      }
      else if (salesDate === "Training") {
        return salesDate;
      }
      else if (salesDate === "Now") {
        return salesDate;
      } else {
        const stdDate = toStdDate(new Date(salesDate + "Z"));
        return `${stdDate}`;
      }
    };
  
    return (
      <Tabs
        sx={{ width: "100%" }}
        variant="scrollable"
        scrollButtons="auto"
        value={selectedTimeTab}
        onChange={handleTabChange}
        textColor="inherit"
        indicatorColor="primary"
      >
        {sortedSwarms.map(([salesDate, swarms], i) => (
          <Tab label={renderTabLabel(salesDate)} key={`daytab-${salesDate}`} value={salesDate} />
        ))}
      </Tabs>
    );
  };

export default DaysTabs;